module.exports = __webpack_public_path__ + "img/logo-letter-4.aa2f09bd.png";